import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { objLength } from '../../../utils/customMethods'

import { CircularProgress } from '@material-ui/core'

import ConversationInformation from './ConversationInformation'
import ConsumerInformation from './ConsumerInformation'
import TransferHistory from './TransferHistory'
import ExtraInformation from './ExtraInformation'
import Survey from './Survey'

import useStyles from './GeneralInformationStyle'

const GeneralInformation = (props) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const generalInformation = useSelector((state) => state.generalInformation)

  const renderContent = () => {
    return !objLength(generalInformation.conversations[props?.chatId]) > 0 &&
      generalInformation?.status?.get_general_info?.loading ? (
      <div className={classes.loadingSection}>
        <CircularProgress size={25} color="primary" />
      </div>
    ) : (
      <>
        <ConversationInformation {...props} />
        <div style={{ height: 15 }} />
        <ConsumerInformation {...props} />
        <div style={{ height: 15 }} />
        <TransferHistory {...props} />
        <div style={{ height: 15 }} />
        <ExtraInformation {...props} />
        <div style={{ height: 15 }} />
        <Survey type="preChat" {...props} />
        <div style={{ height: 15 }} />
        <Survey type="posChat" {...props} />
      </>
    )
  }

  return <div className={classes.root}>{renderContent()}</div>
}

export default memo(GeneralInformation)
